import { isRecurringSchoolCalendarEventActionsEnabled } from "../../../../modules/Utils";
const RREventsFeatureFlagWrapper = ({ children }) => {
  return isRecurringSchoolCalendarEventActionsEnabled() ? children : null;
};

export default RREventsFeatureFlagWrapper;
